import PropTypes from 'prop-types';

//相关说明见schemas/tradingunitrevsion-samples.json

export const OrderPropTypes = PropTypes.shape({
    id: PropTypes.number.isRequired,
    type: PropTypes.string.isRequired,
    orderType: PropTypes.string.isRequired,
    assetAmount: PropTypes.string.isRequired,
    orderPx: PropTypes.string,
    useEntryPrice: PropTypes.bool,
});

export const RevisionPropTypes = PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    timestamp: PropTypes.number.isRequired,
    diff: PropTypes.string.isRequired,
    position: PropTypes.string.isRequired,
    //orders: PropTypes.arrayOf(OrderPropTypes).isRequired,
    orders: PropTypes.arrayOf(OrderPropTypes),
    enable: PropTypes.bool, // 新增 enable 属性
    status: PropTypes.string.isRequired,//prepare、pending、active、end
    rawMsg: PropTypes.string.isRequired,
    URL: PropTypes.string.isRequired,
});

// export const TradingUnitPropTypes = PropTypes.shape({
//     TUID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
//     name: PropTypes.string,
//     exchange: PropTypes.string.isRequired,
//     instId: PropTypes.string.isRequired,
//     leverage: PropTypes.string.isRequired,
//     positionSide: PropTypes.string.isRequired,
// });
export const TradingUnitPropTypes = PropTypes.arrayOf(RevisionPropTypes).isRequired;

export { RevisionPropTypes as Revision, TradingUnitPropTypes as TradingUnit, OrderPropTypes as Order }
